<style lang="scss" scoped>
    @mixin transition($transition-property, $transition-time, $method) {
        transition: $transition-property $transition-time $method;
        -webkit-transition: $transition-property $transition-time $method;
    }

    .label_checkbox {
        display: inline-block;
        margin: 0;
        cursor: pointer;
        font-weight: normal;
        position: relative;

        input[type="checkbox"] {
            position: absolute;
            -webkit-appearance: none;
            appearance: none;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            margin: 0;
            opacity: 0;
            cursor: pointer;

            + span {
                display: inline-block;
                width: 18px;
                height: 18px;
                position: relative;

                &:before {
                    content: "";
                    display: block;
                    width: 18px;
                    height: 18px;
                    border-radius: 1px;
                    border: 1px solid #ACBAC5;
                    @include transition(all, 0.1s, ease-out);
                }

                &:after {
                    content: "";
                    position: absolute;
                    bottom: 5px;
                    left: 6px;
                    display: block;
                    width: 6px;
                    height: 1px;
                    border: 2px solid #fff;
                    border-top-width: 0;
                    border-left-width: 0;
                    -webkit-transform: rotate(45deg);
                    -ms-transform: rotate(45deg);
                    -o-transform: rotate(45deg);
                    transform: rotate(45deg);
                    opacity: 0;
                    @include transition(all, 0.3s, ease-out);
                }
            }
        }

        input[type="checkbox"] {
            &:focus, &:hover {
                + span:before {
                    box-shadow: inset 1px 1px 0px #ACBAC5, inset -1px -1px 0px #ACBAC5;
                }
            }

            &:checked + span {
                &:after {
                    height: 12px;
                    opacity: 1;
                }

                &:before {
                    background-color: #ACBAC5;
                    border-color: #ACBAC5;
                }
            }
        }

        input[type="checkbox"]:disabled {
            + span:before,
            &:checked + span:before {
                border-color: #DCDCDC;
            }

            &:checked + span:before {
                background-color: #DCDCDC;
            }

            + span {
                &:before,
                &:after {
                    cursor: no-drop;
                    box-shadow: none!important;
                }
            }
        }
    }
</style>

<template>
    <label class="label_checkbox" :class="{ 'disabled' : disabled }">
        <input type="checkbox" v-model="model" :disabled="disabled" @change="onChange">
        <span :class="setSpanClass()"></span>
        {{ label }}
    </label>
</template>

<script>
    export default {
        props: {
            value: {
                default: () => null
            },
            label: {
                type: String,
                default: () => null
            },
            textPosition: {
                type: String,
                default: () => 'right'
            },
            disabled: {
                type: Boolean,
                default: () => false
            }
        },
        data () {
            return {
                model: null
            }
        },
        mounted () {
            this.model = this.value
        },
        watch: {
            value (val) {
                this.model = val
            }
        },
        methods: {
            setSpanClass () {
                if (this.label === '') return ''

                return this.textPosition === 'right' ? 'm-r-5 pull-left' : 'm-l-5 pull-right'
            },
            onChange () {
                this.$emit('input', this.model)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/Checkbox.vue